import {
  action,
  computed,
  makeAutoObservable,
  observable,
  runInAction,
} from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { logWithState } from '../functions/console.function';
import { useStoreCommon } from '../hooks/useStore.hook';
import { RootStoreMobX } from './root.store';

export type MapsStoreContextType = {
  token: string;
  mapId: string | null;
};

export class MapsStoreMobX {
  rootStore: RootStoreMobX;
  @observable token: MapsStoreContextType['token'] | null = null;
  @observable mapId?: MapsStoreContextType['mapId'] | null = null;
  @observable load: boolean = false;

  constructor(rootStore: RootStoreMobX) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  @computed get hasToken(): boolean {
    return this.token !== null;
  }

  @computed get hasMapId(): boolean {
    return this.mapId !== null && this.mapId !== undefined;
  }

  @action public init({
    token,
    mapId,
  }: {
    token: MapsStoreContextType['token'];
    mapId?: string;
  }) {
    runInAction(() => {
      this.load = false;
      this.token = token;
      this.mapId = mapId;
      this.load = true;
    });
  }
}

export const ConfigMaps = observer(
  ({
    children,
    token,
    mapId,
  }: {
    children: React.ReactNode;
    token: string;
    mapId?: string;
  }) => {
    const { MapsStore } = useStoreCommon();

    useEffect(() => {
      if (!MapsStore.load && token) {
        logWithState({ state: 'INFO', value: 'ConfigMaps init' });
        MapsStore.init({ token, mapId });
      }

      if (MapsStore.load) {
        logWithState({ state: 'INFO', value: 'ConfigMaps load' });
      }
    }, [MapsStore.load, token, mapId]);

    return MapsStore.load && MapsStore.token ? children : null;
  },
);
